import { Injectable, InjectionToken } from '@angular/core';
import { B2CPolicy, IAuthConfig, IEnvironmentVariables } from '@env/IEnvironment';

export const CONFIG_FILE = new InjectionToken<IEnvironmentVariables>('CONFIG_FILE');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const API_BASE_PLATFORM = new InjectionToken<string>('API_BASE_URL_PLATFORM');
export const API_BASE_NOTIFICATIONS = new InjectionToken<string>('API_BASE_URL_NOTIFICATIONS');
export const API_BASE_HH_URL = new InjectionToken<string>('API_BASE_HH_URL');
export const API_BASE_REGISTRY_URL = new InjectionToken<string>('API_BASE_REGISTRY_URL');
export const AUTH_CONFIG = new InjectionToken<IAuthConfig>('AUTH_CONFIG');
export const B2C_POLICIES = new InjectionToken<B2CPolicy>('B2C_POLICIES');
export const BASE_PERMISSIONS_URL = new InjectionToken<IAuthConfig>('BASE_PERMISSIONS_URL');
export const WCC_LIBRARY_URL = new InjectionToken<string>('WCC_LIBRARY_URL');
export const FEATURE_MODULE_URL = API_BASE_HH_URL;
export const API_BASE_SPECIALTY_PROGRAMS_URL = new InjectionToken<string>('API_BASE_SPECIALTY_PROGRAMS_URL');

export function ConfigFactoryBasePermissionsUrl(apiBaseUrl: string): string {
  return `${apiBaseUrl}/`;
}

export function ConfigFactoryAuthConfig(configService: ConfigService, file: string): IAuthConfig {
  const configData = configService.loadConfig(file);

  return configData.environment.authConfig;
}

export function ConfigFactoryB2CPolicies(configService: ConfigService, file: string): B2CPolicy {
  const configData = configService.loadConfig(file);

  return configData.b2cPolicies;
}


export function apiUrlFactory(configService: ConfigService, config: string) {
  const { environment } = configService.loadConfig(config);

  return {
    apiUrl: environment.apiUrl,
    platformUrl: environment.platformUrl,
    hhApiUrl: environment.hhApiUrl,
    registryUrl: environment.registryUrl,
    wccLibraryUrl: environment.wccLibraryUrl,
    notificationsGatewayUrl: environment.notificationsGatewayUrl,
    specialtyProgramsUrl: environment.specialtyProgramsUrl
  }
}

@Injectable()
export class ConfigService {
  public config: any;

  loadConfig(filePath: string): { environment: IEnvironmentVariables; b2cPolicies: B2CPolicy } {
    if (!this.config) {
      const data = this.loadData(filePath);
      this.config = JSON.parse(data);
    }
    if (!this.config?.environment || !this.config?.b2cPolicies) {
      throw new Error('Configuration data not found!');
    }
    return this.config;
  }

  loadData(filePath: string): string {
    const mimeType = 'application/json';

    const http = new XMLHttpRequest();
    http.open('GET', filePath, false);

    if (http.overrideMimeType) {
      http.overrideMimeType(mimeType);
    }

    http.send();
    http.onerror = () => console.error('Error load config data!');

    if (http.status === 200) {
      return http.responseText;
    } else {
      return '{}';
    }
  }
}
